import gql from "graphql-tag";

export const CREATE_USER_SUBMISSION = gql`
  mutation CREATE_USER_SUBMISSION($input: SayingInput!) {
    CreateSaying(input: $input) {
      errors
      violations {
        message
      }
      entity {
        entityLabel
      }
    }
  }
`;
